// Fix zoom and scroll conflict
document.addEventListener('DOMContentLoaded', function() {
  const lightbox = document.querySelector('.modern-lightbox, .product-media-modal, [class*="lightbox"]');
  
  if (lightbox) {
    let touchStartX = 0;
    let touchEndX = 0;
    let isZooming = false;
    
    lightbox.addEventListener('touchstart', (e) => {
      if (e.touches.length === 2) {
        isZooming = true;
      } else {
        touchStartX = e.changedTouches[0].screenX;
      }
    }, false);
    
    lightbox.addEventListener('touchmove', (e) => {
      if (e.touches.length === 2) {
        isZooming = true;
      }
    }, false);
    
    lightbox.addEventListener('touchend', (e) => {
      if (!isZooming) {
        touchEndX = e.changedTouches[0].screenX;
      }
      setTimeout(() => { isZooming = false; }, 100);
    }, false);
  }
});
